import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiFilesBarCodeService } from 'src/app/api/files/routes/bar-code.service';
import { ApiLocalPortLabel } from 'src/app/api/local/dto/port-label.dto';

@Injectable({ providedIn: 'root' })
export class ViewApiService {
  private readonly localApiPortLabelRouter = inject(ApiFilesBarCodeService);
  printLabel(
    data: ApiLocalPortLabel['printLabel']['body']
  ): Observable<string[]> {
    return this.localApiPortLabelRouter.identificationWorkOrderLabel(data);
  }
}
